import React from 'react';

import { CmStack } from '@/components/uiParts';
import { CurrencyDomainService } from '@/domain/services';

import { KPICard } from './KPICard';

type keyOfsalesSumarry = 'totalPrice' | 'orderCount';

export type SalesSummary = Record<keyOfsalesSumarry, number>;

interface Props {
  salesSummary: SalesSummary;
}

export const SalesSummary: React.FC<Props> = ({ salesSummary }) => {
  const averagePrice =
    (1.0 * salesSummary.totalPrice) / salesSummary.orderCount || 0;

  return (
    <CmStack isInline spacing={5}>
      <KPICard
        title="売上金額"
        desc={CurrencyDomainService.priceFormat(salesSummary.totalPrice)}
        minW="10rem"
      />
      <KPICard
        title="注文数"
        desc={salesSummary.orderCount.toLocaleString()}
        minW="7rem"
      />
      <KPICard
        title="平均注文金額"
        desc={CurrencyDomainService.priceFormat(averagePrice)}
        minW="10rem"
      />
    </CmStack>
  );
};
